export default __webpack_public_path__ + "static/media/product-or-service-quick-reference.770397d4.pdf";